<template>
  <div>
    <b-form-group
      :state="nameState && errors$name.length < 1"
      :invalid-feedback="errors$name"
    >
      <label for="name">Név</label>
      <b-form-input
        id="name"
        v-model="name"
        :state="nameState && errors$name.length < 1"
        type="text"
        placeholder="Az ügyfél neve"
        required
      />
    </b-form-group>
    <b-form-group
      :state="taxcodeState && errors$taxcode.length < 1"
      :invalid-feedback="errors$taxcode"
    >
      <label for="taxcode">Adószám</label>
      <b-form-input
        id="taxcode"
        v-model="taxcode"
        :state="taxcodeState && errors$taxcode.length < 1"
        type="text"
        placeholder="Az ügyfélhez tartozó adószám"
        required
      />
    </b-form-group>
    <b-form-group
      :state="addressState && errors$address.length < 1"
      :invalid-feedback="errors$address"
    >
      <label for="address">Számlázási cím</label>
      <address-input
        id="address"
        v-model="address"
        :state="addressState && errors$address.length < 1"
      />
    </b-form-group>
    <b-form-group
      :state="emailsState &&errors$emails.length < 1"
      :invalid-feedback="errors$emails"
    >
      <label for="brands">Email cím</label>
      <tags-input
        v-model="email"
        :tags="tags"
        :validation="emailsValidation"
        placeholder="Adj meg egy email címet"
        @tags-changed="tagsChanged"
        required
      />
    </b-form-group>
      <b-form-group
      :state="phoneState &&errors$phone.length < 1"
      :invalid-feedback="errors$phone"
    >
      <label for="phone">Telefonszám</label>
      <b-form-input
        id="phone"
        v-model="phone"
        :state="phoneState && errors$phone.length < 1"
        type="text"
        placeholder="Az ügyfélhez fiókhoz tartozó telefonszám"
        required
      />
    </b-form-group>
  </div>
</template>
<style>
</style>
<script>
  import VueTagsInput from '@johmun/vue-tags-input'
  import ObjectEditor from '../../utils/mixins/ObjectEditor'
  import FormValidation from '../../utils/mixins/FormValidation'

  import AddressInput from '../common/AddressInput'

  import customerDefinition from './_customer'

  export default {
    components: {
      'tags-input': VueTagsInput,
      'address-input': AddressInput
    },
    mixins: [ObjectEditor(customerDefinition), FormValidation(['name', 'taxcode', 'emails', 'address', 'phone'])],
    props: {
      errors: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        email: '',
        emailsValidation: [{
          classes: 'not-email',
          rule: (tag) => {
            return !this.validateEmail(tag.text)
          },
          disableAdd: true,
        }],
      }
    },
    computed: {
      nameState: function() {
        return this.name.length > 0
      },
      taxcodeState: function() {
        return this.taxcode.length > 0
      },
      addressState: function() {
        return _.reduce(this.address, (state, value) => {
          return state && value.length > 0
        }, true)
      },
      phoneState: function() {
        return this.phone.length > 0
      },
      emailsState: function() {
        return this.emails.length > 0
      },
      validCustomer: function() {
        return this.nameState && this.phoneState && this.emailsState && this.taxcodeState && this.addressState
      },
      tags: function () {
        return _.map(this.emails, email => ({text: email, classes: "bg-primary"}))
      },
    },
    watch: {
      errors: {
        deep: true,
        handler(errors) {
          if(_.size(errors) === 0) {
            this.clearErrors()
          } else {
            this.parseErrors(errors)
          }
        }
      },
      validCustomer(isValid) {
        this.$emit('validated', isValid)
      }
    },
    methods: {
      tagsChanged(tags) {
        this.emails = _.map(tags, tag => tag.text)
      },
    }
  }
</script>